const PLAN_TYPE = {
    ADVANCED: 'advanced',
    TRANSACTIONAL: 'tiered',
    SUBSCRIPTION: 'subscription',
    FREE: 'free',
    CUSTOM: 'custom',
    DEALER: 'dealer',
    BUNDLE_SUBSCRIPTION: 'bundle_subscription'
}

const PLAN_CARD_TEXT = {
    [PLAN_TYPE.ADVANCED]: {
        heading: 'Subscription with Overage',
        subtext: ''
    },
    [PLAN_TYPE.TRANSACTIONAL]: {
        heading: 'Transactional',
        subtext: 'Transparent tiered pricing - Pay only for the value you use'
    },
    [PLAN_TYPE.SUBSCRIPTION]: {
        heading: 'Subscription',
        subtext: 'Monthly plan for unlimited API use per dealership location. Flat rate.'
    },
    [PLAN_TYPE.FREE]: {
        heading: 'Free',
        subtext: 'Kickstart your journey with a zero-cost free plan'
    },
    [PLAN_TYPE.BUNDLE_SUBSCRIPTION]: {
        heading: 'Dealer Plan',
        subtext: 'Flat-rate monthly pricing for unlimited API calls - No limits, no surprises'
    }
}

const getPlanName = (planType, isBundle, actualPlanName) => {
    if ((isBundle || planType?.toLowerCase() === PLAN_TYPE.SUBSCRIPTION) && actualPlanName) {
        return actualPlanName;
    }
    let retText = '';
    switch (planType?.toLowerCase()) {
        case PLAN_TYPE.SUBSCRIPTION:
            retText = 'Subscription';
            break;
        case PLAN_TYPE.TRANSACTIONAL:
            retText = 'Transactional';
            break;
        case PLAN_TYPE.FREE:
            retText = 'Free';
            break;
        case PLAN_TYPE.ADVANCED:
            retText = 'Advanced';
            break;
        case PLAN_TYPE.BUNDLE_SUBSCRIPTION:
            retText = actualPlanName || 'Dealer Plan';
            break;
        default:
            retText = planType;
            break;
    }
    return retText;
};

const formatNumbers = value => {
    return new Intl.NumberFormat('en-us', {
        maximumFractionDigits: 20
    }).format(value);
};

const getPriceFontSize = (price = 0) => {
    const digitCount = String(price).replace(/\D/g, '').length;
    const fontSizes = {
        1: 34,
        2: 34,
        3: 34,
        4: 34,
        5: 32,
        6: 30,
        7: 28,
        8: 26,
        9: 26,
        10: 24,
    };
    return fontSizes[digitCount] || 24;
};

const getLocationFontSize = (price) => {
    const digitCount = price.toString().replace(/\D/g, '').length;
    const fontSizes = {
        1: 16,
        2: 16,
        3: 16,
        4: 16,
        5: 16,
        6: 16,
        7: 14,
        8: 14,
        9: 14,
        10: 14,
    };
    return fontSizes[digitCount] || 14;
};

const PRICING_PLAN_CTA = {
    ADD_TO_CART: 'Add to Cart',
    SELECTED: 'Selected',
    SELECT_PRICING_PLAN: 'Select'
}

const getPlanCTA = (isAPIinCart, isSelected) => {
    const state = isSelected && isAPIinCart ? 'selectedAndInCart'
        : isAPIinCart ? 'inCart'
            : 'notInCart';
    switch (state) {
        case 'selectedAndInCart':
            return PRICING_PLAN_CTA.SELECTED;
        case 'inCart':
            return PRICING_PLAN_CTA.SELECT_PRICING_PLAN;
        case 'notInCart':
            return PRICING_PLAN_CTA.ADD_TO_CART;
        default:
            return PRICING_PLAN_CTA.ADD_TO_CART;
    }
};

const getPlanType = (plan, isBundle) => {
  let planType =
    plan?.plan === PLAN_TYPE.CUSTOM
      ? plan.name
      : plan.plan || plan.type || plan.planType;
  return isBundle ? PLAN_TYPE.DEALER : planType;
};

const parsePrice = (plan) => Number(plan?.price) || Number(plan?.subscriptionPrice) || 0;

const sortByPrice = (a, b) => {
    const priceA = parsePrice(a);
    const priceB = parsePrice(b);
    return priceA - priceB;
};

const getPlansToShowForAPI = (allPricingPlans = []) => {
    if (!Array.isArray(allPricingPlans) || allPricingPlans.length === 0) {
        return [];
    }
    const dealerPlans = [];
    const otherPlans = [];
    for (const plan of allPricingPlans) {
        if (plan.status === 'active') {
            if (plan.dealerPriceChecked) {
                dealerPlans.push(plan);
            } else {
                otherPlans.push(plan);
            }
        }
    }
    // return only dealer plans if any exist, else return other plans
    return dealerPlans.length ? dealerPlans.sort(sortByPrice) : otherPlans.sort(sortByPrice);
};

const getSelctedPlanOfAPI = (api)=>{
    // Check both resourcePricingPlanId (bundles/new format) and apiPricingPlanId (legacy API format)
    const pricingPlanId = api?.resourcePricingPlanId || api?.apiPricingPlanId;
    if(pricingPlanId){
         let plans = api?.details?.plans?.filter((plan=>plan.id === pricingPlanId))
         return plans?.[0] || null
    }
    return null
}

const API_PLANS_MODAL_TITLE = {
    NO_PLAN_SELECTED: 'Select Pricing Plan',
    PLAN_SELECTED: 'Edit Pricing Plan'
}

const getSinglePlanId = (plans) => {
    const plansToShow = getPlansToShowForAPI(plans);
    return plansToShow?.length === 1 ? plansToShow[0]?.id : undefined;
};

const formatCurrency = (value, locale = 'en-US', currency = 'USD') => {
  const numericValue = Number(value);
  const safeValue = Number.isFinite(numericValue) ? numericValue : 0;

    return new Intl.NumberFormat(locale, {
    style: 'currency',
        currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(safeValue);
};
const mapCartForDirectory = (cart) => {
  return cart?.map((item) => ({
    ...item,
    apiId: item.apiId || item.resourceId,
    pricingPlanId: item.pricingPlanId || item.resourcePricingPlanId,
    apiPricingPlanId: item.apiPricingPlanId || item.resourcePricingPlanId || item.pricingPlanId,
  }));
};

export { PLAN_CARD_TEXT, PLAN_TYPE, PRICING_PLAN_CTA, getPlanName, formatNumbers, getPlanCTA, getPlansToShowForAPI, getPlanType, getSelctedPlanOfAPI, parsePrice, API_PLANS_MODAL_TITLE, getSinglePlanId, formatCurrency, mapCartForDirectory, getPriceFontSize, getLocationFontSize }

